import React from 'react';

import I18n from 'i18n-react';

function ClearAllFilters(props) {
	const { clearFilters } = props;

	return (
		// eslint-disable-next-line react/button-has-type
		<button className="ta-filter-clear" onClick={clearFilters}>
			<span>{I18n.translate('filters.clearAllFilters')}</span>
			<i className="icon-close" />
		</button>
	);
}

export default ClearAllFilters;



// WEBPACK FOOTER //
// ./src/page/searchResultPage/components/ClearAllFilters/ClearAllFilters.jsx